import { Component } from '@angular/core';
import { AboutComponent } from '../about/about';
import { GalleryComponent } from '../gallery/gallery';
import { LocationComponent } from '../location/location';
import { ContactComponent } from '../contact/contact';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    AboutComponent,
    GalleryComponent,
    LocationComponent,
    ContactComponent
  ],
  templateUrl: './home.html',
  styleUrls: ['./home.scss']
})
export class HomeComponent {}
